import ModalFrame, { ModalSize } from "@Components/Feedback/Modal/Frame";
import { setModalActions } from "@Core/Gql";
import React, { createContext, ReactNode, useContext, useState } from "react";

export interface ModalContextInterface {
    open: (content: ReactNode) => void;
    setSize: (size: ModalSize) => void;
    close: () => void;
}

export const ModalContext = createContext<ModalContextInterface>({
    open: () => {},
    setSize: () => {},
    close: () => {},
});

export function useModalContext() {
    return useContext(ModalContext);
}

export default function ModalContainer({ children }: { children: ReactNode }) {
    const [size, setSize] = useState<ModalSize>('md');
    const [content, setContent] = useState<ReactNode | null>(null);
    const close = () => setContent(null);

    const actions = {
        open: (node: ReactNode) => setContent(node),
        setSize,
        close,
    };

    setModalActions(actions);

    return (
        <ModalContext.Provider value={actions}>
            {children}

            <ModalFrame
                isOpen={!!content}
                size={size}
                onRequestClose={close}
            >
                {content}
            </ModalFrame>
        </ModalContext.Provider>
    );
}
